import { Str } from '@supercharge/strings/dist';

export default function camelCaseKeys(object: Object) {
    return Object.entries(object).reduce((carry: Object, [key, value]) => {
        carry[Str(key).camel().get() as keyof Object] = value;

        return carry;
    }, {});
}
